module.exports = __webpack_public_path__ + "img/error404.eac79f7f.png";